import { render } from "./addModuleHouseVip.vue?vue&type=template&id=fc9606a0"
import script from "./addModuleHouseVip.vue?vue&type=script&lang=js"
export * from "./addModuleHouseVip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__